<mat-tab-group [(selectedIndex)]="reportsIndex" #tab>
	@for (report of reportNames; track report) {
	<mat-tab [label]="report"></mat-tab>
	}
</mat-tab-group>
<div class="main-container">
	@if (!isLoaded) {
	<div class="center">
		<mat-spinner [diameter]="30"></mat-spinner>
	</div>
	}
	@if (isLoaded && reports[reportsIndex] && reports[reportsIndex].length > 0) {
	<div class="reports-container">
		@for (report of reports[reportsIndex]; track report) {
		<mat-card class="report-card" (click)="rowSelected(report.ID)">
			<mat-card-title>{{ report.Name }}</mat-card-title>
			<mat-card-subtitle>{{ report.Description }}</mat-card-subtitle>
		</mat-card>
		}
	</div>
	}
	@if (isLoaded && (!reports[reportsIndex] || reports[reportsIndex].length == 0)) {
	<div class="center">
		There are currently no reports of this type
	</div>
	}
</div>